import React, { useEffect } from 'react'
import { Form, Input, Button, DatePicker, Select } from 'antd'
import { memoAPI } from '../services/api'
import { showSuccessAlert, showErrorAlert } from '../utils/customAlert'
import { getCurrentTime, toISOString, createTime } from '../utils/timezone'

export default function MemoForm({ memo, onFinish }) { 
const [form] = Form.useForm() 

useEffect(() => { 
if (memo) { 
// 处理建站时间字段
const memoData = { 
...memo, 
site_time: memo.site_time ? createTime(memo.site_time) : getCurrentTime()
} 
form.setFieldsValue(memoData) } else {
// 清空表单并设置默认建站时间为当前时间
form.resetFields()
form.setFieldsValue({
site_time: getCurrentTime(),
finish: false
})
}
}, [memo, form])

// 添加错误边界处理
const handleDateChange = (date) => {
  console.log('DatePicker value changed:', date);
  return date;
};

const handleFinish = async (values) => {
try {
const userId = localStorage.getItem('userId')
// 自动trim所有字符串字段，但保留空字符串
const trimmedValues = {
...values,
site: values.site?.trim() || '',
keyword: values.keyword?.trim() || '',
admin_url: values.admin_url?.trim() || '',
username: values.username?.trim() || '',
password: values.password?.trim() || '',
ip: values.ip?.trim() || '',
 bt: values.bt?.trim() || '',
ftp_user: values.ftp_user?.trim() || '',
ftp_pass: values.ftp_pass?.trim() || '',
group: values.group?.trim() || '',
remark: values.remark?.trim() || '',
auditor: values.auditor?.trim() || ''
}

// 发送数据到后端
const data = {
...trimmedValues,
userId,
site_time: toISOString(trimmedValues.site_time),
finish: Boolean(values.finish)
}

console.log('Sending data to backend:', data);

if (memo) {
await memoAPI.update(memo.id, data)
showSuccessAlert('successful!', 'successful')
} else {
await memoAPI.create(data)
showSuccessAlert('Added successfully!', 'Added successfully')
// Clear the form after adding successfully
form.resetFields()
}

onFinish()
} catch (err) {
if (err.response && err.response.status === 400) {
const data = err.response.data;

// If the URL or IP already exists, display a simple prompt
if (data?.message && (data.message.includes('already exists') || data.message.includes('Duplicate submission') || data.message.includes('已存在'))) {
showErrorAlert(data.message, '提示', () => {
// Clear the form after clicking OK
form.resetFields()
});
} else {
// Show validation error details
let errorMessage = data?.message || 'Operation failed';
if (data?.details && Array.isArray(data.details)) {
  const fieldErrors = data.details.map(detail => `${detail.field}: ${detail.message}`).join('\n');
  errorMessage = `Validation errors:\n${fieldErrors}`;
}
showErrorAlert(errorMessage, 'Error');
}
} else if (err.request) {
// Network connection error
showErrorAlert('Network connection error, please check the network', 'Network error');
} else {
// Other errors
showErrorAlert('Operation failed, please try again', 'Error');
}
}
}

return (
<Form form={form} layout="vertical" onFinish={handleFinish}>
<Form.Item name="site" label="URL" rules={[{ required: true, message: 'Please enter the URL' }]}>
<Input />
</Form.Item>
<Form.Item name="keyword" label="Keyword">
<Input />
</Form.Item>
<Form.Item name="admin_url" label="Backend address">
<Input />
</Form.Item>
<Form.Item name="username" label="Username">
<Input />
</Form.Item>
<Form.Item name="password" label="Password">
<Input />
</Form.Item>
<Form.Item 
  name="ip" 
  label="IP"
  rules={[
    {
      pattern: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      message: '请输入有效的IP地址格式 (例如: 192.168.1.1)',
      validateTrigger: 'onBlur'
    }
  ]}
>
<Input placeholder="例如: 192.168.1.1" />
</Form.Item>
<Form.Item name="bt" label="所属宝塔(bt)">
<Input placeholder="例如: hk-1 / us-west / xxx机"/>
</Form.Item>
<Form.Item name="ftp_user" label="FTP user">
<Input />
</Form.Item>
<Form.Item name="ftp_pass" label="FTP pass">
<Input />
</Form.Item>
<Form.Item name="group" label="Website group">
<Input placeholder="Please enter the group name" />
</Form.Item>
<Form.Item name="site_time" label="Website time">
<DatePicker
showTime
format="YYYY-MM-DD HH:mm"
placeholder="Select website time"
style={{ width: '100%' }}
onChange={handleDateChange}
/>
</Form.Item>
<Form.Item name="finish" label="Finish Status">
<Select placeholder="Select finish status">
<Select.Option value={true}>是</Select.Option>
<Select.Option value={false}>否</Select.Option>
</Select>
</Form.Item>
<Form.Item name="remark" label="Remarks">
<Input />
</Form.Item>
<Form.Item name="auditor" label="Auditor">
<Input placeholder="Enter auditor name" />
</Form.Item>
<Form.Item>
<Button type="primary" htmlType="submit">{memo ? 'Modify': 'Add'}</Button>

</Form.Item>

</Form>
)
}